import {
  Cars64,
  Tractors64,
  Livestock64,
  FarmMachinery64,
  BeddingFeed64,
  FarmersMarket64,
  FarmersNoticeboard64,
  FarmingServices64,
  FarmSheds64,
  FarmTools64,
  FeedingEquipment64,
  FencingEquipment64,
  Fertilisers64,
  OtherFarming64,
  PlantMachinery64,
  Poultry64,
  VintageMachinery64,
  Farming64,
  TractorsFromDealerships64,
} from '../../../components/Toolkit/Base64/Sections';
export interface Map {
  [name: string]: JSX.Element;
}

const FarmingIcons: Map = {
  cars: <Cars64 />,
  tractors: <Tractors64 />,
  tractorsfromdealerships: <TractorsFromDealerships64 />,
  livestock: <Livestock64 />,
  machinery: <FarmMachinery64 />,
  plantmachinery: <PlantMachinery64 />,
  farmproduce: <BeddingFeed64 />,
  farmersmarket: <FarmersMarket64 />,
  farmersnoticeboard: <FarmersNoticeboard64 />,
  farmservices: <FarmingServices64 />,
  farmsheds: <FarmSheds64 />,
  farmtools: <FarmTools64 />,
  feedingequipment: <FeedingEquipment64 />,
  fencingequipment: <FencingEquipment64 />,
  fertilisers: <Fertilisers64 />,
  otherfarming: <OtherFarming64 />,
  poultry: <Poultry64 />,
  vintagemachinery: <VintageMachinery64 />,
  farming: <Farming64 />,
};

export default FarmingIcons;
